import * as TextVariables from "../../assets/Variables/TextVariables.js";
import Colors from "../../assets/Variables/ColorsVariables.js";
import { Spaces } from "../../assets/Variables/SpaceVariables.js";

export const mainPaper = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "1110px",
  boxSizing: "border-box",
  borderRadius: "12px",
  padding: Spaces.Size_5,
  gap: Spaces.Size_8,

};

export const linkButton = {
  width: "110px",
  fontFamily: TextVariables.Caption_2,
  color: Colors.Secondary_800,
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  padding: `${Spaces.Size_1} ${Spaces.Size_2}`,
  gap: "2px",
  borderRadius: Spaces.Size_2,
  marginRight: "10px"
};
